"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPageHost = createPageHost;
exports.getCacheName = getCacheName;
exports.getCompletedViews = getCompletedViews;
exports.getPageKey = getPageKey;
exports.refreshOnCacheReentry = refreshOnCacheReentry;
exports.selectCachedViews = selectCachedViews;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function getPageKey(route) {
  var ignored = route.meta && route.meta.cacheIgnoreQuery || ['temp'];
  var query = Object.keys(route.query || {}).filter(function (key) {
    return ignored.indexOf(key) === -1;
  }).sort().map(function (key) {
    return [key, route.query[key]];
  });
  return JSON.stringify([route.path, query]);
}
function getCacheName(route) {
  return 'Page_' + Array.from(getPageKey(route)).map(function (char) {
    return char.charCodeAt(0).toString(16);
  }).join('_');
}

// A cached page already loads itself during created/mounted on its first visit.
// Refresh only on later keep-alive activations so the retained filters and
// pagination are reused without issuing a duplicate initial request.
function refreshOnCacheReentry(vm, refresh) {
  if (vm._pageCacheActivatedOnce) {
    refresh.call(vm);
    return true;
  }
  vm._pageCacheActivatedOnce = true;
  return false;
}

// A completed editor should not remain in the tab cache. For query-based
// decoration editors, discard other drafts of the same saved resource too.
function getCompletedViews(views, route) {
  var sameResource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!sameResource || !route.query || !route.query.id) return [route];
  var siblings = views.filter(function (view) {
    return view.path === route.path && view.query && String(view.query.id) === String(route.query.id);
  });
  return [route].concat(_toConsumableArray(siblings.filter(function (view) {
    return getPageKey(view) !== getPageKey(route);
  })));
}

// Only explicitly disposable pages participate in eviction. Forms and other
// pages may contain unsaved state, so they remain cached until their tab closes.
function selectCachedViews(views, currentRoute, accessOrder) {
  var disposableLimit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 8;
  var cacheable = views.filter(function (view) {
    return view.meta.tabCache !== false;
  });
  var currentKey = getPageKey(currentRoute);
  var disposable = cacheable.filter(function (view) {
    return view.meta.cacheDisposable === true;
  }).sort(function (a, b) {
    var rank = function rank(view) {
      return getPageKey(view) === currentKey ? accessOrder.length : accessOrder.indexOf(getPageKey(view));
    };
    return rank(b) - rank(a);
  });
  var selected = new Set(disposable.slice(0, disposableLimit).map(getPageKey));
  return cacheable.filter(function (view) {
    return view.meta.cacheDisposable !== true || selected.has(getPageKey(view));
  });
}

// Isolate $route for the whole tab subtree, including nested router-views.
function createPageHost(Vue, name) {
  return Vue.extend({
    name: name,
    props: {
      pageRoute: {
        type: Object,
        required: true
      }
    },
    watch: {
      pageRoute: function pageRoute(route) {
        this._routerRoot._route = route;
      }
    },
    beforeCreate: function beforeCreate() {
      var context = Object.create(this._routerRoot);
      Vue.util.defineReactive(context, '_route', this.$options.propsData.pageRoute);
      this._routerRoot = context;
    },
    activated: function activated() {
      // vue-router 3.0 only registers on mount/prepatch. On cache reactivation
      // restore the active instance used by navigation guards and enter hooks.
      var _register = function register(vm) {
        var data = vm.$vnode && vm.$vnode.data;
        if (data && data.registerRouteInstance) data.registerRouteInstance(vm, vm);else if (data && data.routerView) {
          // Inactive RouterView v3.0 renders from its local cache without the
          // registration callback; all business outlets here use default views.
          var record = vm.$route.matched[data.routerViewDepth];
          if (record && record.components.default) record.instances.default = vm;
        }
        vm.$children.forEach(_register);
      };
      this.$children.forEach(_register);
    },
    render: function render(h) {
      return h('router-view');
    }
  });
}